import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { FilterSelector, LoadingIcon } from "../index";
import { BaseUrl, Coockies_name } from "../../constants";
import { get_villes } from "../../Utils/villes/get_villes";
import { useCookies } from "react-cookie";
import { get_Activity } from "../../Utils/Activities/Activities";
import { ImgInput } from "../../Utils/ImgInput";
import { DefaultPartner } from "../../constants";
import FormData from "form-data";
import { FaTrash } from "react-icons/fa";

const STEPS = ["Médias", "Entreprise", "Contact", "Contenu", "Réseaux Sociaux"];

// ─── Shared primitives ────────────────────────────────────────────────────────

const inputCls = (error) =>
  `w-full bg-gray-100 text-gray-800 border rounded-lg py-2.5 px-3 text-sm focus:outline-none focus:bg-white transition ${
    error ? "border-red-400 focus:border-red-400" : "border-gray-200 focus:border-gray-400"
  }`;

const Field = ({ label, required, error, children }) => (
  <div className="flex flex-col gap-1">
    <label className="text-xs font-bold uppercase tracking-wide text-gray-600">
      {label}{required && <span className="text-red-500 ml-1">*</span>}
    </label>
    {children}
    {error && <p className="text-red-500 text-xs mt-0.5">{error}</p>}
  </div>
);

const TextAreaField = ({ label, required, value, onChange, maxLength = 500 }) => (
  <Field label={label} required={required}>
    <textarea
      className={`${inputCls(false)} min-h-[90px] resize-y`}
      value={value || ""}
      onChange={onChange}
      maxLength={maxLength}
    />
    <span className="text-xs text-gray-400 text-right self-end">
      {(value || "").length}/{maxLength}
    </span>
  </Field>
);

// Logo: new upload (File) → object URL, else fall back to avatar_Url from API
const getLogoSrc = (data) => {
  if (data.logo instanceof File) return URL.createObjectURL(data.logo);
  if (data.logo && typeof data.logo === "string" && data.logo !== "") return data.logo;
  if (data.avatar_Url) return data.avatar_Url;
  return null;
};

// Cover: new upload (File) → object URL, else fall back to img_cover_Url from API
const getCoverSrc = (data) => {
  if (data.cover instanceof File) return URL.createObjectURL(data.cover);
  if (data.cover && typeof data.cover === "string" && data.cover !== "") return data.cover;
  if (data.img_cover_Url) return data.img_cover_Url;
  return null;
};

// ─── Step 0 : Médias ──────────────────────────────────────────────────────────

const StepMedia = ({ data, setdata }) => {
  const logoSrc = getLogoSrc(data);
  const coverSrc = getCoverSrc(data);

  return (
    <div className="flex flex-col gap-6">
      <p className="text-sm text-gray-500">
        Cliquez sur une image pour la remplacer, ou supprimez-la avec le bouton rouge.
      </p>
      <div className="flex flex-row gap-8 flex-wrap justify-center">

        {/* LOGO */}
        <div className="flex flex-col items-center gap-2">
          <span className="text-xs font-bold uppercase tracking-wide text-gray-600">
            Logo <span className="text-red-500">*</span>
          </span>
          {logoSrc ? (
            <div className="relative">
              <label className="cursor-pointer block">
                <img
                  src={logoSrc}
                  alt="Logo"
                  className="w-28 h-28 object-cover rounded-xl border-2 border-gray-200 shadow hover:opacity-80 transition"
                />
                <ImgInput aspectRatio={1} call={(file) => setdata({ ...data, logo: file, logo_selected: true })} />
              </label>
              <button
                type="button"
                onClick={() => setdata({ ...data, logo: null, avatar_Url: null, logo_selected: false })}
                className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 text-white rounded-full w-7 h-7 flex items-center justify-center shadow-md transition"
              >
                <FaTrash size={11} />
              </button>
            </div>
          ) : (
            <label className="w-28 h-28 rounded-xl border-2 border-dashed border-gray-300 bg-gray-50 hover:border-red-400 hover:bg-red-50 cursor-pointer flex flex-col items-center justify-center gap-1 transition">
              <svg className="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              <span className="text-[11px] text-gray-400 font-medium">Ratio 1:1</span>
              <ImgInput aspectRatio={1} call={(file) => setdata({ ...data, logo: file, logo_selected: true })} />
            </label>
          )}
        </div>

        {/* COVER */}
        <div className="flex flex-col items-center gap-2 flex-1 min-w-[220px]">
          <span className="text-xs font-bold uppercase tracking-wide text-gray-600">
            Cover <span className="text-red-500">*</span>
          </span>
          {coverSrc ? (
            <div className="relative w-full">
              <label className="cursor-pointer block">
                <img
                  src={coverSrc}
                  alt="Cover"
                  className="w-full h-24 object-cover rounded-xl border-2 border-gray-200 shadow hover:opacity-80 transition"
                />
                <ImgInput width={1200} height={500} call={(file) => setdata({ ...data, cover: file, cover_selected: true })} />
              </label>
              <button
                type="button"
                onClick={() => setdata({ ...data, cover: null, img_cover_Url: null, cover_selected: false })}
                className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 text-white rounded-full w-7 h-7 flex items-center justify-center shadow-md transition"
              >
                <FaTrash size={11} />
              </button>
            </div>
          ) : (
            <label className="w-full h-24 rounded-xl border-2 border-dashed border-gray-300 bg-gray-50 hover:border-red-400 hover:bg-red-50 cursor-pointer flex flex-col items-center justify-center gap-1 transition">
              <svg className="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              <span className="text-[11px] text-gray-400 font-medium">1200 × 500 px</span>
              <ImgInput width={1200} height={500} call={(file) => setdata({ ...data, cover: file, cover_selected: true })} />
            </label>
          )}
        </div>

      </div>
    </div>
  );
};

// ─── Step 1 : Entreprise ──────────────────────────────────────────────────────

const StepEntreprise = ({ data, setdata, villes, Activities }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div className="md:col-span-2">
      <Field label="Raison sociale" required>
        <input
          className={inputCls(false)}
          type="text"
          value={data.nome_entreprise || ""}
          onChange={(e) => setdata({ ...data, nome_entreprise: e.target.value })}
          placeholder="Nom de l'entreprise"
        />
      </Field>
    </div>

    <Field label="ICE" required>
      <input
        className={inputCls(false)}
        type="text"
        value={data.identificateur_entreprise || ""}
        onChange={(e) => setdata({ ...data, identificateur_entreprise: e.target.value })}
      />
    </Field>

    <Field label="Représentant" required>
      <input
        className={inputCls(false)}
        type="text"
        value={data.representant_entreprise || ""}
        onChange={(e) => setdata({ ...data, representant_entreprise: e.target.value })}
      />
    </Field>

    <Field label="Fonction" required>
      <input
        className={inputCls(false)}
        type="text"
        value={data.role_dans_entriprise || ""}
        onChange={(e) => setdata({ ...data, role_dans_entriprise: e.target.value })}
      />
    </Field>

    <Field label="Adresse" required>
      <input
        className={inputCls(false)}
        type="text"
        value={data.adrress || ""}
        onChange={(e) => setdata({ ...data, adrress: e.target.value })}
      />
    </Field>

    <div>
      <FilterSelector
        title="Ville"
        Filter={data.ville}
        setFilter={(value) => setdata({ ...data, ville: value })}
        options={villes}
        styles="!max-w-full !w-full"
        required
      />
    </div>

    <div>
      <FilterSelector
        title="Secteur d'activité"
        Filter={data.activity_entrprise}
        setFilter={(value) => setdata({ ...data, activity_entrprise: value })}
        options={Activities}
        styles="!max-w-full !w-full"
        required
      />
    </div>

    <div className="md:col-span-2">
      <FilterSelector
        title="Statut"
        Filter={data._status}
        setFilter={(value) => setdata({ ...data, _status: value })}
        options={[
          { value: "Approved", name: "Approved" },
          { value: "Rejected", name: "Rejected" },
          { value: "Pending", name: "Pending" },
        ]}
        styles="!max-w-full !w-full"
        required
      />
    </div>
  </div>
);

// ─── Step 2 : Contact ─────────────────────────────────────────────────────────

const StepContact = ({ data, setdata }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div className="md:col-span-2">
      <Field label="Email" required>
        <input
          className={inputCls(false)}
          type="email"
          value={data.email || ""}
          onChange={(e) => setdata({ ...data, email: e.target.value })}
          placeholder="partenaire@email.com"
        />
      </Field>
    </div>

    <div className="md:col-span-2">
      <Field label="Mot de passe">
        <input
          className={inputCls(false)}
          type="password"
          value={data.password || ""}
          onChange={(e) => setdata({ ...data, password: e.target.value })}
          placeholder="Laisser vide pour ne pas modifier"
        />
      </Field>
    </div>

    <Field label="Numéro Téléphone" required>
      <input
        className={inputCls(false)}
        type="text"
        value={data.numero_telephone || ""}
        onChange={(e) => setdata({ ...data, numero_telephone: e.target.value })}
      />
    </Field>

    <Field label="Téléphone Fixe">
      <input
        className={inputCls(false)}
        type="text"
        value={data.numero_telephone_fix || ""}
        onChange={(e) => setdata({ ...data, numero_telephone_fix: e.target.value })}
      />
    </Field>
  </div>
);

// ─── Step 3 : Contenu ─────────────────────────────────────────────────────────

const StepContenu = ({ data, setdata }) => (
  <div className="flex flex-col gap-4">
    <TextAreaField
      label="Offer"
      required
      value={data.offer}
      onChange={(e) => setdata({ ...data, offer: e.target.value })}
    />
    <TextAreaField
      label="Description"
      required
      value={data.description}
      onChange={(e) => setdata({ ...data, description: e.target.value })}
    />
    <TextAreaField
      label="Note"
      value={data.note}
      onChange={(e) => setdata({ ...data, note: e.target.value })}
    />
  </div>
);

// ─── Step 4 : Réseaux Sociaux ─────────────────────────────────────────────────

const StepReseaux = ({ data, setdata }) => (
  <div className="flex flex-col gap-4">
    <p className="text-sm text-gray-400 bg-gray-50 rounded-lg px-3 py-2 border border-gray-100">
      Tous les champs de cette section sont optionnels.
    </p>
    <Field label="Facebook URL">
      <input
        className={inputCls(false)}
        type="text"
        value={data.facebook_url || ""}
        onChange={(e) => setdata({ ...data, facebook_url: e.target.value })}
        placeholder="facebook.com/..."
      />
    </Field>
    <Field label="Instagram URL">
      <input
        className={inputCls(false)}
        type="text"
        value={data.instagram_url || ""}
        onChange={(e) => setdata({ ...data, instagram_url: e.target.value })}
        placeholder="instagram.com/..."
      />
    </Field>
    <Field label="TikTok URL">
      <input
        className={inputCls(false)}
        type="text"
        value={data.tiktok_url || ""}
        onChange={(e) => setdata({ ...data, tiktok_url: e.target.value })}
        placeholder="tiktok.com/..."
      />
    </Field>
    <Field label="Website URL">
      <input
        className={inputCls(false)}
        type="text"
        value={data.website_url || ""}
        onChange={(e) => setdata({ ...data, website_url: e.target.value })}
        placeholder="website.com/..."
      />
    </Field>
  </div>
);

// ─── Main component ───────────────────────────────────────────────────────────

const UpdatePartner = ({ open, OnClick, partner, setRefresh }) => {
  const [cookies] = useCookies([Coockies_name]);
  const [data, setdata] = useState(DefaultPartner);
  const [loading, setloading] = useState(false);
  const [step, setStep] = useState(0);
  const [saved, setSaved] = useState(false);
  const [villes, setvilles] = useState([]);
  const [Activities, setActivities] = useState([]);

  const hadlerClose = () => { OnClick(); };

  useEffect(() => {
    setdata(partner || DefaultPartner);
    setStep(0);
    setSaved(false);
  }, [partner, open]);

  useEffect(() => {
    get_villes(setvilles);
    get_Activity(setActivities);
  }, []);

  const handle_submit = async () => {
    setloading(true);
    setSaved(false);
    const formData = new FormData();
    formData.append("images", data.cover);
    formData.append("images", data.logo);
    formData.append("data", JSON.stringify(data));
    try {
      await fetch(`${BaseUrl}/admin/update_partner`, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: { Authorization: `Bearer ${cookies.accesToken}` },
        referrerPolicy: "no-referrer",
        body: formData,
      });
      setRefresh((val) => val + 1);
      setSaved(true);
    } catch (err) {
      console.error(err);
    } finally {
      setloading(false);
    }
  };

  const handleStepClick = (i) => {
    setStep(i);
    setSaved(false);
  };

  return (
    <Dialog open={open} keepMounted fullWidth maxWidth="md" onClose={hadlerClose}>

      {/* ── Header ── */}
      <div className="bg-white px-6 pt-6 pb-4 border-b border-gray-100">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-xl font-bold text-gray-800">Mettre à Jour Ce Partenaire</h2>
            <p className="text-xs text-gray-400 mt-0.5">
              <span className="text-red-500">*</span> Champs obligatoires
            </p>
          </div>
          <div className="flex items-center gap-2">
            {saved && (
              <span className="text-xs text-green-600 bg-green-50 border border-green-200 rounded-lg px-3 py-1.5 font-medium">
                ✓ Sauvegardé
              </span>
            )}
            <button
              type="button"
              onClick={hadlerClose}
              className="text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center transition text-lg font-bold"
            >
              ×
            </button>
          </div>
        </div>

        {/* Stepper */}
        <div className="flex items-center mt-5">
          {STEPS.map((label, i) => (
            <React.Fragment key={i}>
              <button
                type="button"
                onClick={() => handleStepClick(i)}
                className="flex flex-col items-center group"
              >
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all group-hover:opacity-80
                  ${i === step ? "bg-red-500 text-white" : "bg-gray-100 text-gray-500"}`}
                >
                  {i + 1}
                </div>
                <span className={`text-[10px] mt-1 font-semibold whitespace-nowrap
                  ${i === step ? "text-red-500" : "text-gray-400"}`}
                >
                  {label}
                </span>
              </button>
              {i < STEPS.length - 1 && (
                <div className="flex-1 h-[2px] mx-1 mb-4 rounded bg-gray-200" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* ── Content ── */}
      <DialogContent className="!px-6 !py-5">
        <div className="min-h-[300px]">
          {step === 0 && <StepMedia data={data} setdata={setdata} />}
          {step === 1 && <StepEntreprise data={data} setdata={setdata} villes={villes} Activities={Activities} />}
          {step === 2 && <StepContact data={data} setdata={setdata} />}
          {step === 3 && <StepContenu data={data} setdata={setdata} />}
          {step === 4 && <StepReseaux data={data} setdata={setdata} />}
        </div>

        {/* ── Navigation ── */}
        <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-100">
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => handleStepClick(step - 1)}
              disabled={step === 0}
              className="px-5 py-2 rounded-lg border border-gray-300 text-gray-600 text-sm font-medium disabled:opacity-30 hover:bg-gray-50 transition"
            >
              ← Précédent
            </button>
            <button
              type="button"
              onClick={() => handleStepClick(step + 1)}
              disabled={step === STEPS.length - 1}
              className="px-5 py-2 rounded-lg border border-gray-300 text-gray-600 text-sm font-medium disabled:opacity-30 hover:bg-gray-50 transition"
            >
              Suivant →
            </button>
          </div>

          <button
            type="button"
            onClick={handle_submit}
            disabled={loading}
            className="px-6 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white text-sm font-bold transition flex items-center gap-2 disabled:opacity-60"
          >
            {LoadingIcon(loading)}
            Sauvegarder
          </button>
        </div>
      </DialogContent>

    </Dialog>
  );
};

export default UpdatePartner;
